import React from "react";

const StudentsForTeachers = () => {
    return (
        <div className="min-h-screen bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-20">
            <div className="max-w-7xl mx-auto text-center">
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-blue-400 to-purple-500 mb-6">
                    Students for Teachers
                </h1>
                <p className="text-gray-300 text-lg sm:text-xl mb-10 max-w-3xl mx-auto">
                    We help home tutors connect with genuine students who are actively seeking personal academic guidance at home.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
                {/* Feature 1 */}
                <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 shadow-md hover:shadow-lg transition hover:-translate-y-1 hover:bg-gray-700 duration-300">
                    <h3 className="text-xl font-semibold text-green-400 mb-2">Verified Student Leads</h3>
                    <p className="text-gray-300">
                        Get connected with interested and verified students for home tuition in your preferred subjects.
                    </p>
                </div>

                {/* Feature 2 */}
                <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 shadow-md hover:shadow-lg transition hover:-translate-y-1 hover:bg-gray-700 duration-300">
                    <h3 className="text-xl font-semibold text-green-400 mb-2">Location Based Matching</h3>
                    <p className="text-gray-300">
                        Receive student leads tailored to your chosen locations and teaching strengths.
                    </p>
                </div>

                {/* Feature 3 */}
                <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 shadow-md hover:shadow-lg transition hover:-translate-y-1 hover:bg-gray-700 duration-300">
                    <h3 className="text-xl font-semibold text-green-400 mb-2">Direct Contact</h3>
                    <p className="text-gray-300">
                        Communicate easily with students or their parents via WhatsApp or direct call.
                    </p>
                </div>

                {/* Feature 4 */}
                <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 shadow-md hover:shadow-lg transition hover:-translate-y-1 hover:bg-gray-700 duration-300">
                    <h3 className="text-xl font-semibold text-green-400 mb-2">No Hidden Fees</h3>
                    <p className="text-gray-300">
                        Transparent pricing – only pay for the leads you get. No hidden or surprise charges.
                    </p>
                </div>

                {/* Feature 5 */}
                <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 shadow-md hover:shadow-lg transition hover:-translate-y-1 hover:bg-gray-700 duration-300">
                    <h3 className="text-xl font-semibold text-green-400 mb-2">1000+ Students Connected</h3>
                    <p className="text-gray-300">
                        We’ve already helped 1000+ students find home tutors — join our growing network.
                    </p>
                </div>

                {/* Feature 6 */}
                <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 shadow-md hover:shadow-lg transition hover:-translate-y-1 hover:bg-gray-700 duration-300">
                    <h3 className="text-xl font-semibold text-green-400 mb-2">Pan-India Support & Demo Assistance</h3>
                    <p className="text-gray-300">
                        We are present in multiple cities and help you arrange and prepare for demo classes.
                    </p>
                </div>

                {/* Feature 7 */}
                <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 shadow-md hover:shadow-lg transition hover:-translate-y-1 hover:bg-gray-700 duration-300">
                    <h3 className="text-xl font-semibold text-green-400 mb-2">Demo Class Preparation</h3>
                    <p className="text-gray-300">
                        Need help before facing the student? We provide expert guidance to crack your demo.
                    </p>
                </div>

                {/* Feature 8 */}
                <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 shadow-md hover:shadow-lg transition hover:-translate-y-1 hover:bg-gray-700 duration-300">
                    <h3 className="text-xl font-semibold text-green-400 mb-2">Syllabus & Study Material</h3>
                    <p className="text-gray-300">
                        Get structured syllabus plans and quality material to teach with confidence.
                    </p>
                </div>
            </div>

            <div className="text-center mt-12 flex flex-col sm:flex-row gap-6 justify-center items-center">
                <a
                    href="https://wa.me/919999999999"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-green-500 text-white text-lg font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-green-600 hover:scale-105 transition-transform duration-300"
                >
                    Get Students on WhatsApp
                </a>

                <a
                    href="/contact"
                    className="bg-blue-500 text-white text-lg font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-blue-600 hover:scale-105 transition-transform duration-300"
                >
                    Contact Us
                </a>
            </div>

        </div>
    );
};

export default StudentsForTeachers;
